var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { MessageByTypeEnum } from "../Models";
import { convertEmojis, createTextLinks_, fileName, fileSize, fileUrl, } from "../Utils";
import { GPT_MESSAGE_SCORE_UPDATE_URL_PATH } from "../globals";
import { postReq } from "../request";
import Tippy from "@tippyjs/react";
import TimeAgo from "../Timeago";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw"; // For allowing raw HTML
import remarkGfm from "remark-gfm"; // For GitHub-Flavored Markdown (breaks, tables, etc.)theme
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
var ChatMessage = function (props) {
    var _a;
    var message_type = props.message.message_type;
    useEffect(function () {
        setScrollBottom();
    }, [message_type]);
    // const filename = (message: ChatMessagePaylodObj) => {
    //   return JSON.parse(message.message).fileName;
    // };
    // const fileurl = (message: ChatMesppsagePaylodObj) => {
    //   return JSON.parse(message.message).fileUrl;
    // };
    // const filesize = () => {
    //   return formatBytes(JSON.parse(props.message.message).fileSize, 0);
    // };
    var getMessageTime = function () {
        // let myDate = new Date(props.message.created_time * 1000);
        // let dateStr = myDate.getDate() + "/" + (myDate.getMonth() + 1) + "/" + myDate.getFullYear()
        // //+ " " + myDate.getHours() + ":" + myDate.getMinutes() + ":" + myDate.getSeconds()
        // return dateStr;
        return props.message.created_time * 1000;
    };
    var submitGPTFeedback = function (feedback) {
        console.log("score");
        props.message.gpt_relavance_score = feedback;
        props.updateMessage(props.message);
        // Push to server
        var wait = postReq(GPT_MESSAGE_SCORE_UPDATE_URL_PATH + "/" + props.sessionId, props.message);
        wait.then(function (response) {
            console.log(response);
        });
    };
    var setScrollBottom = function () {
        setTimeout(function () {
            var elem = document.getElementsByClassName("chat__messages-track")[0];
            if (elem)
                elem.scrollTop = elem.scrollHeight;
        }, 100);
    };
    return (_jsx(Tippy, __assign({ appendTo: "parent", content: _jsx(TimeAgo, { date: getMessageTime() }), 
        // visible={props.message.session_id ? true : false}
        disabled: props.message.id && ((_a = props.message) === null || _a === void 0 ? void 0 : _a.status) != "SENDING" ? false : true }, { children: _jsx("div", __assign({ className: "chat__messages-bubble chat__message-type-".concat(message_type) }, { children: (function () {
                // setScrollBottom();
                switch (message_type) {
                    case "TEXT":
                        return (_jsxs(_Fragment, { children: [props.message.from === MessageByTypeEnum.GPT ?
                                    _jsx(ReactMarkdown, __assign({ className: "markdown-wrapper", remarkPlugins: [remarkGfm], rehypePlugins: [rehypeRaw], components: {
                                            code: function (props) {
                                                var children = props.children, className = props.className, node = props.node, rest = __rest(props, ["children", "className", "node"]);
                                                var match = /language-(\w+)/.exec(className || '');
                                                return match ? (_jsx(SyntaxHighlighter
                                                // {...rest}
                                                , { 
                                                    // {...rest}
                                                    PreTag: "div", children: String(children).replace(/\n$/, ''), language: match[1], style: dark })) : (_jsx("code", __assign({}, rest, { className: className }, { children: children })));
                                            },
                                        } }, { children: props.message.message })) :
                                    _jsx("span", { className: "actual", dangerouslySetInnerHTML: {
                                            __html: createTextLinks_(convertEmojis(props.message.message)),
                                        } }), props.message.from === MessageByTypeEnum.GPT &&
                                    props.message.sources &&
                                    JSON.parse(props.message.sources).length > 0 ? (_jsx("div", __assign({ className: "source-label-sec" }, { children: _jsx("div", __assign({ className: "source-label-list" }, { children: JSON.parse(props.message.sources).map(function (value, index) {
                                            return (_jsx("div", __assign({ className: "source-label" }, { children: _jsx("p", __assign({ className: "source-label-ellipsis" }, { children: _jsxs("a", __assign({ target: "_blank", rel: "noopener noreferrer", href: value, className: "source-label-link" }, { children: [value, _jsx("span", { className: "source-label-link-absolute" })] })) })) })));
                                        }) })) }))) : (_jsx(_Fragment, {})), props.message.from === MessageByTypeEnum.GPT ? (_jsxs("div", __assign({ className: "feedback-actions" }, { children: [_jsx("span", __assign({ onClick: function () { return submitGPTFeedback(1); }, className: "btn positive-btn ".concat(props.message.gpt_relavance_score === 1
                                                ? "active"
                                                : "") }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor" }, { children: _jsx("path", { d: "M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" }) })) })), _jsx("span", __assign({ onClick: function () { return submitGPTFeedback(2); }, className: "btn negative-btn ".concat(props.message.gpt_relavance_score === 2
                                                ? "active"
                                                : "") }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor" }, { children: _jsx("path", { d: "M18 9.5a1.5 1.5 0 11-3 0v-6a1.5 1.5 0 013 0v6zM14 9.667v-5.43a2 2 0 00-1.105-1.79l-.05-.025A4 4 0 0011.055 2H5.64a2 2 0 00-1.962 1.608l-1.2 6A2 2 0 004.44 12H8v4a2 2 0 002 2 1 1 0 001-1v-.667a4 4 0 01.8-2.4l1.4-1.866a4 4 0 00.8-2.4z" }) })) }))] }))) : (_jsx(_Fragment, {}))] }));
                    case "FILE":
                        return (_jsx("div", __assign({ className: "chat__header-user" }, { children: _jsxs("div", __assign({ className: "chat__header-user-table xs-mb-0" }, { children: [_jsx("div", __assign({ className: "chat__header-user-img chat__header-user-file-img" }, { children: _jsx("img", { src: "https://d2p078bqz5urf7.cloudfront.net/cloud/assets/livechat/chatfile.png" }) })), _jsxs("div", __assign({ className: "chat__header-user-name chat__header-user-table-cell file-info" }, { children: [_jsx("a", { className: "chat__header-user-name", target: "_blank", href: fileUrl(props.message), dangerouslySetInnerHTML: {
                                                    __html: createTextLinks_(fileName(props.message)),
                                                } }), _jsx("div", __assign({ className: "file-info-name", style: { marginTop: "5px" } }, { children: _jsx("span", { children: fileSize(props.message) }) }))] }))] })) })));
                    case "FETCHING":
                        return (_jsx("div", { children: _jsxs("div", __assign({ className: "loading-dots" }, { children: [props.message.message, _jsxs("span", { children: [_jsx("i", { className: "loading-dots--dot" }), _jsx("i", { className: "loading-dots--dot" }), _jsx("i", { className: "loading-dots--dot" })] })] })) }));
                    default:
                        return _jsx("div", {});
                }
            })() })) })));
};
export default ChatMessage;
